import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import styles from './linkbutton.module.scss';

interface Props {
  text?: string;
  asLink?: boolean;
  to?: string;
  onClick?: () => void;
  className?: string;
}

const LinkButton = ({ text, asLink, to, onClick: onClick, className }: Props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;

  // helpers
  const getText = () => text ? text : tLabels("linkButton.showAll")

  // render
  if (asLink) {
    return (
      <Link className={`${styles.link}${className ? " " + className : ""}`} onClick={onClick} to={to || ""}>
        {getText()}
      </Link>
    );
  } else {
    return (
      <span className={`${styles.link}${className ? " " + className : ""}`} onClick={onClick}>
        {getText()}
      </span>
    );
  }
}

export default LinkButton;
